import store from 'store'
import {
  hexMD5
} from '../util/md5.js'

import font from '../util/font.js';
import http from '../util/http.js';

let _ = {
  getLog: function() {
    var currentPageTitle = document.title;
    var dHref = location.href;
    var dOrigin = location.origin;
    var currentPageUrl = dHref.replace(dOrigin, '');
    currentPageUrl = currentPageUrl.replace('/#', '');
    http.post('/user/log', {
      name: currentPageTitle,
      source: 5,
      uri: currentPageUrl
    }).then(function(res) {
      if (res.code == 200) {}
    }).catch(function(error) {

    });
  },
  isEmpty: function(value) {
    if (value == undefined) {
    	return true;
    }
    switch (typeof value) {
      case 'undefined':
        return true;
      case 'string':
        if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
        break;
      case 'boolean':
        if (!value) return true;
        break;
      case 'number':
        if (isNaN(value)) return true;
        break;
      case 'object':
        if (null === value || value.length === 0) return true;
        for (var i in value) {
          return false;
        }
        return true;
    }
    return false;
  },
  contains: function(string, target) {
    if (_.isEmpty(string)) {
      return false;
    }
    return string.includes(target);
  },
  jsonParams(params) {
    let obj = new Object();
    if (_.isEmpty(params)) {
      return obj;
    }

    for (let key in params) {
      if (!_.isEmpty(params[key])) {
        obj[key] = params[key];
      }
    }
    return obj;
  },
  outBatch(batch) {
    switch (batch) {
      case 1:
        return '本一批'
        break;
      case 2:
        return '本二批'
        break;
      case 4:
        return '专科批'
        break;
    }
  },
	outBatchXGK: function(batch) {
		switch (batch) {
			case 2:
				return '本科批'
				break;
			case 4:
				return '专科批'
				break;
		}
	},
  outGroup: function(group) {
  	if (_.isEmpty(group)) {
  		return "";
  	}
  	return "【专业组"+ group +"】";
  },
  outDel: function(del) {
    switch (del) {
      case 1:
        return '高'
        break;
      case 2:
        return '中'
        break;
      case 3:
        return '低'
        break;
      case 4:
        return '极低'
        break;
    }
  },
  outAbc: function(abc) {
  	switch (abc) {
  		case 1:
  			return '1'
  			break;
  		case 2:
  			return '2'
  			break;
  		case 3:
  			return '3'
  			break;
  		case 4:
  			return '4'
  			break;
  		case 5:
  			return '5'
  			break;
  		case 6:
  			return '6'
  			break;
  		case 7:
  			return '7'
  			break;
  		case 8:
  			return '8'
  			break;
  		case 9:
  			return '9'
  			break;
  		case 10:
  			return '10'
  			break;
  		case 11:
  			return '11'
  			break;
  		case 12:
  			return '12'
  			break;
  		case 13:
  			return '13'
  			break;
  		case 14:
  			return '14'
  			break;
  		case 15:
  			return '15'
  			break;
  		case 16:
  			return '16'
  			break;
  		case 17:
  			return '17'
  			break;
  		case 18:
  			return '18'
  			break;
  		case 19:
  			return '19'
  			break;
  		case 20:
  			return '20'
  			break;
  		case 21:
  			return '21'
  			break;
  		case 22:
  			return '22'
  			break;
  		case 23:
  			return '23'
  			break;
  		case 24:
  			return '24'
  			break;
  		case 25:
  			return '25'
  			break;
  		case 26:
  			return '26'
  			break;
  		case 27:
  			return '27'
  			break;
  		case 28:
  			return '28'
  			break;
  		case 29:
  			return '29'
  			break;
  		case 30:
  			return '30'
  			break;
  		case 31:
  			return '31'
  			break;
  		case 32:
  			return '32'
  			break;
  		case 33:
  			return '33'
  			break;
  		case 34:
  			return '34'
  			break;
  		case 35:
  			return '35'
  			break;
  		case 36:
  			return '36'
  			break;
  		case 37:
  			return '37'
  			break;
  		case 38:
  			return '38'
  			break;
  		case 39:
  			return '39'
  			break;
  		case 40:
  			return '40'
  			break;
  		case 41:
  			return '41'
  			break;
  		case 42:
  			return '42'
  			break;
  		case 43:
  			return '43'
  			break;
  		case 44:
  			return '44'
  			break;
  		case 45:
  			return '45'
  			break;
  	}
  },
  outProvinces(provinces) {
    switch (provinces) {
      case 11:
        return '北京'
        break;
      case 12:
        return '天津'
        break;
      case 13:
        return '河北'
        break;
      case 14:
        return '山西'
        break;
      case 15:
        return '内蒙古'
        break;
      case 21:
        return '辽宁'
        break;
      case 22:
        return '吉林'
        break;
      case 23:
        return '黑龙江'
        break;
      case 31:
        return '上海'
        break;
      case 32:
        return '江苏'
        break;
      case 33:
        return '浙江'
        break;
      case 34:
        return '安徽'
        break;
      case 35:
        return '福建'
        break;
      case 36:
        return '江西'
        break;
      case 37:
        return '山东'
        break;
      case 41:
        return '河南'
        break;
      case 42:
        return '湖北'
        break;
      case 43:
        return '湖南'
        break;
      case 44:
        return '广东'
        break;
      case 45:
        return '广西'
        break;
      case 46:
        return '海南'
        break;
      case 50:
        return '重庆'
        break;
      case 51:
        return '四川'
        break;
      case 52:
        return '贵州'
        break;
      case 53:
        return '云南'
        break;
      case 54:
        return '西藏'
        break;
      case 61:
        return '陕西'
        break;
      case 62:
        return '甘肃'
        break;
      case 63:
        return '青海'
        break;
      case 64:
        return '宁夏'
        break;
      case 65:
        return '新疆'
        break;
      case 71:
        return '台湾'
        break;
      case 81:
        return '香港'
        break;
      case 82:
        return '澳门'
        break;
    }
  },

  outSort(sort) {
    // let arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    let arr = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25',
    '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45'];
    return arr[sort];
  },
  out(val, isUnicode) {
    if (_.isEmpty(val)) {
      return '--';
    } else {
      if (!_.isEmpty(isUnicode) && isUnicode) {
        val = _.outUnicode(val);
      }
      return val;
    }
  },
  isSichuan: function() {
    let provinceId = store.get('provinceId');
    if (_.isEmpty(provinceId)) {
      return false;
    }
    if (provinceId === 51 || (!_.isEmpty(provinceId.data) && provinceId.data === 51)) {
      return true;
    } else {
      return false;
    }
  },
  getStorageProvinceId: function() {
    let provinceId = store.get('provinceId');
    return provinceId;
  },
  outEqName: function() {
    if (_.isSichuan()) {
      //四川返回 等位分
      return '等位分';
    } else {
      //其他区域返回等同分
      return '等同分';
    }
  },
  outEqScore: function(eqScore, alleleScore, isUnicode) {
    let val = eqScore;
    if (_.isSichuan()) {
      //四川 等位分
      val = alleleScore;
    }
    if (_.isEmpty(val)) {
      return '--';
    } else {
      if (!_.isEmpty(isUnicode) && isUnicode) {
        val = _.outUnicode(val);
      }
      return 'D' + val;
    }
  },
  outWenli(val) {
    if (_.isEmpty(val)) {
      return '--';
    } else if (val == 1) {
      return '历史';
    } else if (val == 5) {
      return '物理';
    } else {
      return val;
    }
  },
  outKL: function(val) {
  	if (_.isEmpty(val)) {
  		return '--';
  	} else if (val == 1) {
  		return '历史组';
  	} else if (val == 5) {
  		return '物理组';
  	} else {
  		return val;
  	}
  },
  outVoluntaryDesc: function(batch) {
  	switch (batch) {
  		case 0:
  			return '提前批B段'
  			break;

  		case 1:
  			return '本科批A段'
  			break;

  		case 2:
  			return '本科批B段'
  			break;
  		case 4:
  			return '专科批'
  			break;
  	}
  },
	outSubject:function(val, val2) {
		if (_.isEmpty(val) || _.isEmpty(val2)) {
			return '--';
		} else if (val == 1 && val2 == 12) {
			return '历史【化学+生物】';
		} else if (val == 1 && val2 == 13) {
			return '历史【化学+政治】';
		} else if (val == 1 && val2 == 14) {
			return '历史【化学+地理】';
		} else if (val == 1 && val2 == 23) {
			return '历史【生物+政治】';
		} else if (val == 1 && val2 == 24) {
			return '历史【生物+地理】';
		} else if (val == 1 && val2 == 34) {
			return '历史【政治+地理】';
		} else if (val == 5 && val2 == 12) {
			return '物理【化学+生物】';
		} else if (val == 5 && val2 == 13) {
			return '物理【化学+政治】';
		} else if (val == 5 && val2 == 14) {
			return '物理【化学+地理】';
		} else if (val == 5 && val2 == 23) {
			return '物理【生物+政治】';
		} else if (val == 5 && val2 == 24) {
			return '物理【生物+地理】';
		} else if (val == 5 && val2 == 34) {
			return '物理【政治+地理】';
		} else {
			return val;
		}
	},
  outTqBatch: function(val) {
    if (_.isEmpty(val)) {
      return '--';
    } else if (val == 11) {
      return '本科提前批(国家专项)';
    } else if (val == 12) {
      return '本科提前批A段';
    } else if (val == 13) {
      return '本科提前批(高校专项)';
    } else if (val == 14) {
      return '本科提前批B段';
    } else if (val == 31) {
      return '专科提前批';
    } else {
      return val;
    }
  },
  outExam(val) {
    if (_.isEmpty(val)) {
      return '--';
    } else if (val == 0) {
      return '零诊';
    } else if (val == 1) {
      return '一诊';
    } else if (val == 2) {
      return '二诊';
    } else if (val == 3) {
      return '三诊';
    } else if (val == 4) {
      return '四诊';
    } else if (val == 11) {
      return '省联考第一次';
    } else {
      return val;
    }
  },
  outUnicode: function(val) {
    if (_.isEmpty(val)) {
      return val;
    }
    /*替换unicode 值*/
    var str = val.replace(/35FFF/g, ';&#x');
    //截取第一个; 最后加;
    str = str.substring(1, str.length) + ';';
    return str;
  },
  decrypt: function(val) {
    if (_.isEmpty(val)) {
      return val;
    }
    for (let key in font) {
      val = val.replace(new RegExp(key, "g"), font[key]);
    }
    return val;
  },
  getImg: function(property, type) {
    if (_.isEmpty(property)) {
      return null;
    }
    var thumb = null;
    var propertyArray = (property + "").split(".");
    var id = propertyArray[0];
    var fileType = propertyArray[1];
    var thumbSize = {
      original: "",
      x150: "_150X150",
      x300: "_300X300",
      x640: "_640X640"
    };
    if (fileType == "gif" || type == 0) {
      thumb = thumbSize.original;
    } else if (type == 1) {
      thumb = thumbSize.x150;
    } else if (type == 2) {
      thumb = thumbSize.x300;
    } else if (type == 3) {
      thumb = thumbSize.x640;
    } else {
      thumb = thumbSize.x150;
    }
    var ids = id.split("_");
    var prefix = null;
    var fileName = null;
    if (ids.length == 1) {
      prefix = "thisiscommonhh";
      fileName = ids[0];
    } else if (ids.length == 2) {
      prefix = ids[0];
      fileName = ids[1];
    }
    var digest = hexMD5(fileName);
    var sb = prefix + "/";
    var level = 3;
    for (var i = 0, length = digest.length; i < length && level != 0; i += 2) {
      if (level != 3) {
        sb += "/";
      }
      sb += (digest.substring(i, i + 2));
      --level;
    }
    sb += "/";
    sb += fileName;
    return "https://img.sx678.cn/" + sb + "/" + id + thumb + "." + fileType;
  },
  timeFormat: function(date, format) {
    if (_.isEmpty(date) || _.isEmpty(format)) {
      return '';
    }
    date = new Date(date);
    if (!date || date.toUTCString() == 'Invalid Date') {
      return '';
    }
    var map = {
      "m": date.getMonth() + 1, //月份
      "d": date.getDate(), //日
      "h": date.getHours(), //小时
      "M": date.getMinutes(), //分
      "s": date.getSeconds(), //秒
      "q": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };

    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
      var v = map[t];
      if (v !== undefined) {
        if (all.length > 1) {
          v = '0' + v;
          v = v.substr(v.length - 2);
        }
        return v;
      } else if (t === 'y') {
        return (date.getFullYear() + '').substr(4 - all.length);
      }
      return all;
    });
    return format;
  },
  scrollTop: function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  isMobile: function() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"
    ];
    var flag = false;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = true;
        break;
      }
    }
    return flag;
  },
	getJoint: function(val) {
		var jointString;
		for (var i in val) {
			if (i == 0) {
				jointString = val[i];
			} else {
				jointString += "，" + val[i];
			}
		}
		return jointString;
	},
	getJoint2: function(val) {
		var jointString;
		for (var i in val) {
			if (i == 0) {
				jointString = val[i].specName;
			} else {
				jointString += "，" + val[i].specName;
			}
		}
		return jointString;
	}
}

export default _



// WEBPACK FOOTER //
// ./src/util/util.js